import { render, staticRenderFns } from "./LearningGoalsForBlockModal.vue?vue&type=template&id=439e6fc8&"
import script from "./LearningGoalsForBlockModal.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsForBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports